import React from 'react';
import { getScoreBand } from '@/lib/scoring';

interface ScoreBadgeProps {
  score: number;
  showLabel?: boolean;
  size?: 'sm' | 'md';
}

export default function ScoreBadge({ score, showLabel = true, size = 'sm' }: ScoreBadgeProps) {
  const band = getScoreBand(score);
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${sizeClass}`}
      style={{ backgroundColor: band.bgColor, color: band.color, border: `1px solid ${band.borderColor}` }}
    >
      <span className="font-mono tabular-nums font-semibold">{score}</span>
      {showLabel && <span>{band.label}</span>}
    </span>
  );
}